var map = {
	"./1.jpg": "./images/partners/1.jpg",
	"./2.jpg": "./images/partners/2.jpg",
	"./3.jpg": "./images/partners/3.jpg",
	"./ALDORA.": "./images/partners/ALDORA.png",
	"./ALDORA.png": "./images/partners/ALDORA.png",
	"./CAIRO RUNNERS.": "./images/partners/CAIRO RUNNERS.png",
	"./CAIRO RUNNERS.png": "./images/partners/CAIRO RUNNERS.png",
	"./FROZY-TWIST.": "./images/partners/FROZY-TWIST.png",
	"./FROZY-TWIST.png": "./images/partners/FROZY-TWIST.png",
	"./HOMES EGYPT.": "./images/partners/HOMES EGYPT.png",
	"./HOMES EGYPT.png": "./images/partners/HOMES EGYPT.png",
	"./HORIZON BLANC.": "./images/partners/HORIZON BLANC.png",
	"./HORIZON BLANC.png": "./images/partners/HORIZON BLANC.png",
	"./akl-mama.": "./images/partners/akl-mama.png",
	"./akl-mama.png": "./images/partners/akl-mama.png",
	"./asap.": "./images/partners/asap.png",
	"./asap.png": "./images/partners/asap.png",
	"./deltaelnile.": "./images/partners/deltaelnile.png",
	"./deltaelnile.png": "./images/partners/deltaelnile.png",
	"./emtelak.": "./images/partners/emtelak.png",
	"./emtelak.png": "./images/partners/emtelak.png",
	"./kazlak.": "./images/partners/kazlak.png",
	"./kazlak.png": "./images/partners/kazlak.png",
	"./lOGO PNG/AKL MAMA.": "./images/partners/lOGO PNG/AKL MAMA.png",
	"./lOGO PNG/AKL MAMA.png": "./images/partners/lOGO PNG/AKL MAMA.png",
	"./lOGO PNG/ASAP.": "./images/partners/lOGO PNG/ASAP.png",
	"./lOGO PNG/ASAP.png": "./images/partners/lOGO PNG/ASAP.png",
	"./lOGO PNG/CAIRO RUNNERS.": "./images/partners/lOGO PNG/CAIRO RUNNERS.png",
	"./lOGO PNG/CAIRO RUNNERS.png": "./images/partners/lOGO PNG/CAIRO RUNNERS.png",
	"./lOGO PNG/County.": "./images/partners/lOGO PNG/County.png",
	"./lOGO PNG/County.png": "./images/partners/lOGO PNG/County.png",
	"./lOGO PNG/HORIZON BLANC.": "./images/partners/lOGO PNG/HORIZON BLANC.png",
	"./lOGO PNG/HORIZON BLANC.png": "./images/partners/lOGO PNG/HORIZON BLANC.png",
	"./lOGO PNG/ITOUCH.": "./images/partners/lOGO PNG/ITOUCH.png",
	"./lOGO PNG/ITOUCH.png": "./images/partners/lOGO PNG/ITOUCH.png",
	"./lOGO PNG/NAPA.": "./images/partners/lOGO PNG/NAPA.png",
	"./lOGO PNG/NAPA.png": "./images/partners/lOGO PNG/NAPA.png",
	"./lOGO PNG/REAL..": "./images/partners/lOGO PNG/REAL..png",
	"./lOGO PNG/REAL..png": "./images/partners/lOGO PNG/REAL..png",
	"./lOGO PNG/SHIEKH EL 3ARAV.": "./images/partners/lOGO PNG/SHIEKH EL 3ARAV.png",
	"./lOGO PNG/SHIEKH EL 3ARAV.png": "./images/partners/lOGO PNG/SHIEKH EL 3ARAV.png",
	"./lOGO PNG/URBANLEADS.": "./images/partners/lOGO PNG/URBANLEADS.png",
	"./lOGO PNG/URBANLEADS.png": "./images/partners/lOGO PNG/URBANLEADS.png",
	"./lOGO PNG/misr el ghad.": "./images/partners/lOGO PNG/misr el ghad.png",
	"./lOGO PNG/misr el ghad.png": "./images/partners/lOGO PNG/misr el ghad.png",
	"./lavie.": "./images/partners/lavie.png",
	"./lavie.png": "./images/partners/lavie.png",
	"./meshwar.": "./images/partners/meshwar.png",
	"./meshwar.png": "./images/partners/meshwar.png",
	"./misr el-ghad.": "./images/partners/misr el-ghad.png",
	"./misr el-ghad.png": "./images/partners/misr el-ghad.png",
	"./office.": "./images/partners/office.png",
	"./office.png": "./images/partners/office.png",
	"./real.": "./images/partners/real.png",
	"./real.png": "./images/partners/real.png",
	"./sheikh.": "./images/partners/sheikh.png",
	"./sheikh.png": "./images/partners/sheikh.png",
	"./tejjara.": "./images/partners/tejjara.png",
	"./tejjara.png": "./images/partners/tejjara.png",
	"./urban-leads.": "./images/partners/urban-leads.png",
	"./urban-leads.png": "./images/partners/urban-leads.png"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./images/partners recursive ^\\.\\/.*$";


//////////////////
// WEBPACK FOOTER
// ./images/partners ^\.\/.*$
// module id = ./images/partners recursive ^\.\/.*$
// module chunks = 0